module.exports = {
	"config": {
		"linkPrefix": "/dao-contracts",
		"name": "@digix/dao-contracts",
		"license": "Apache-2.0",
		"version": "1.0.0",
		"description": "Smart contracts for DigixDAO",
		"homepage": "https://github.com/DigixGlobal/dao-contracts#readme",
		"author": "DigixGlobal",
		"buildTime": "2018-11-27T07:27:10.578Z",
		"target": "scripts/doxity",
		"src": "contracts/interactive/*",
		"dir": "pages/docs",
		"source": "https://github.com/DigixGlobal/doxity-gatsby-starter-project/archive/a4886b7a7a04c018ac04fed3125d7d4785e74bed.tar.gz",
		"out": "docs",
		"interaction": {},
		"whitelist": {
			"all": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"Dao": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoFundingManager": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoIdentity": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoInformation": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoRewardsManager": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoRewardsManagerExtras": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoSpecialProposal": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoSpecialVotingClaims": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoStakeLocking": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoVoting": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoVotingClaims": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			},
			"DaoWhitelisting": {
				"abi": true,
				"methods": true,
				"bytecode": false,
				"source": true
			}
		}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Dao.json",
				"ext": "json",
				"name": "Dao",
				"extname": ".json",
				"basename": "Dao.json",
				"dirname": "docs",
				"stem": "Dao",
				"path": "docs/Dao.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/Dao.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Dao.json",
			"path": "/docs/Dao/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoFundingManager.json",
				"ext": "json",
				"name": "DaoFundingManager",
				"extname": ".json",
				"basename": "DaoFundingManager.json",
				"dirname": "docs",
				"stem": "DaoFundingManager",
				"path": "docs/DaoFundingManager.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoFundingManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoFundingManager.json",
			"path": "/docs/DaoFundingManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoIdentity.json",
				"ext": "json",
				"name": "DaoIdentity",
				"extname": ".json",
				"basename": "DaoIdentity.json",
				"dirname": "docs",
				"stem": "DaoIdentity",
				"path": "docs/DaoIdentity.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoIdentity.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoIdentity.json",
			"path": "/docs/DaoIdentity/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoInformation.json",
				"ext": "json",
				"name": "DaoInformation",
				"extname": ".json",
				"basename": "DaoInformation.json",
				"dirname": "docs",
				"stem": "DaoInformation",
				"path": "docs/DaoInformation.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoInformation.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoInformation.json",
			"path": "/docs/DaoInformation/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoRewardsManager.json",
				"ext": "json",
				"name": "DaoRewardsManager",
				"extname": ".json",
				"basename": "DaoRewardsManager.json",
				"dirname": "docs",
				"stem": "DaoRewardsManager",
				"path": "docs/DaoRewardsManager.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoRewardsManager.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoRewardsManager.json",
			"path": "/docs/DaoRewardsManager/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoRewardsManagerExtras.json",
				"ext": "json",
				"name": "DaoRewardsManagerExtras",
				"extname": ".json",
				"basename": "DaoRewardsManagerExtras.json",
				"dirname": "docs",
				"stem": "DaoRewardsManagerExtras",
				"path": "docs/DaoRewardsManagerExtras.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoRewardsManagerExtras.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoRewardsManagerExtras.json",
			"path": "/docs/DaoRewardsManagerExtras/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoSpecialProposal.json",
				"ext": "json",
				"name": "DaoSpecialProposal",
				"extname": ".json",
				"basename": "DaoSpecialProposal.json",
				"dirname": "docs",
				"stem": "DaoSpecialProposal",
				"path": "docs/DaoSpecialProposal.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoSpecialProposal.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoSpecialProposal.json",
			"path": "/docs/DaoSpecialProposal/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoSpecialVotingClaims.json",
				"ext": "json",
				"name": "DaoSpecialVotingClaims",
				"extname": ".json",
				"basename": "DaoSpecialVotingClaims.json",
				"dirname": "docs",
				"stem": "DaoSpecialVotingClaims",
				"path": "docs/DaoSpecialVotingClaims.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoSpecialVotingClaims.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoSpecialVotingClaims.json",
			"path": "/docs/DaoSpecialVotingClaims/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoStakeLocking.json",
				"ext": "json",
				"name": "DaoStakeLocking",
				"extname": ".json",
				"basename": "DaoStakeLocking.json",
				"dirname": "docs",
				"stem": "DaoStakeLocking",
				"path": "docs/DaoStakeLocking.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoStakeLocking.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoStakeLocking.json",
			"path": "/docs/DaoStakeLocking/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoVoting.json",
				"ext": "json",
				"name": "DaoVoting",
				"extname": ".json",
				"basename": "DaoVoting.json",
				"dirname": "docs",
				"stem": "DaoVoting",
				"path": "docs/DaoVoting.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoVoting.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoVoting.json",
			"path": "/docs/DaoVoting/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoVotingClaims.json",
				"ext": "json",
				"name": "DaoVotingClaims",
				"extname": ".json",
				"basename": "DaoVotingClaims.json",
				"dirname": "docs",
				"stem": "DaoVotingClaims",
				"path": "docs/DaoVotingClaims.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoVotingClaims.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoVotingClaims.json",
			"path": "/docs/DaoVotingClaims/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "DaoWhitelisting.json",
				"ext": "json",
				"name": "DaoWhitelisting",
				"extname": ".json",
				"basename": "DaoWhitelisting.json",
				"dirname": "docs",
				"stem": "DaoWhitelisting",
				"path": "docs/DaoWhitelisting.json",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/docs/DaoWhitelisting.json",
				"isAbsolute": false
			},
			"requirePath": "docs/DaoWhitelisting.json",
			"path": "/docs/DaoWhitelisting/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/home/rohit/Develop/instance-copy/dao-contracts/scripts/doxity/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 386
// module chunks = 0